import { Box } from "native-base";

export const GraphViolinStackWrapper = ({ children }) => (
  <Box p={{ base: 3, md: 6 }} maxW='1000px' w='full'  mx='auto'>{children}</Box>
);